export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';
export const RETRIEVE_USER_REQUEST = 'RETRIEVE_USER_REQUEST';
export const RETRIEVE_USER_SUCCESS = 'RETRIEVE_USER_SUCCESS';
export const RETRIEVE_USER_FAILURE = 'RETRIEVE_USER_FAILURE';
export const SET_AUTH_ERROR_MESSAGE = 'SET_AUTH_ERROR_MESSAGE';
export const AUTH_FAILURE = 'AUTH_FAILURE';
export const UPDATE_AVAILABLE = 'UPDATE_AVAILABLE';
export const FORCED_USER_LOG_OUT = 'FORCED_USER_LOG_OUT';


export const loginRequest = (value) => {
  return {
    type: LOGIN_REQUEST,
    payload: value,
  };
};

export const loginSuccess = () => {
  return {
    type: LOGIN_SUCCESS,
  };
};

export const loginFailure = (error) => {
  return {
    type: LOGIN_FAILURE,
    payload: {
      error,
    },
  };
};

export const updateAvailable = () => {
  setTimeout(() => (location.reload(true)), 5000);
  return {
    type: UPDATE_AVAILABLE,
  };
};

export const requestLogout = () => {
  return {
    type: LOGOUT_REQUEST,
  };
};

export const logoutSuccess = () => {
  return {
    type: LOGOUT_SUCCESS,
  };
};

export const logoutFailure = (error) => {
  return {
    type: LOGOUT_FAILURE,
    payload: {
      error,
    },
  };
};

export const retrieveUserRequest = () => {
  return {
    type: RETRIEVE_USER_REQUEST,
  };
};

export const retrieveUserSuccess = (user) => {
  return {
    type: RETRIEVE_USER_SUCCESS,
    payload: user,
  };
};

export const retrieveUserFailure = (error) => {
  return {
    type: RETRIEVE_USER_FAILURE,
    payload: {
      error,
    },
  };
};

export const setAuthErrorMessage = (error) => {
  return {
    type: SET_AUTH_ERROR_MESSAGE,
    payload: {
      error,
    },
  };
};

export const authFailure = () => {
  return {
    type: AUTH_FAILURE,
  };
};

export const forcedUserLogOut = (value) => {
  return {
    type: FORCED_USER_LOG_OUT,
    payload: value,
  };
};
